@if (error()) {
  <h2 class="text-2xl pb-2" i18n>Something has gone wrong!</h2>
  <p i18n>Unable to load the application changelog</p>
} @else {
  <div class="flex flex-col gap-3">
    @if (availableVersions().length) {
      <div class="controls flex justify-center space-x-2 my-4">
        <button
          (click)="activeIndex.set(activeIndex() - 1)"
          [disabled]="activeIndex() <= 0"
        [ngClass]="{
        'bg-gray-100 dark:bg-gray-900': activeIndex() <= 0,
        'hover:bg-gray-300': activeIndex() > 0,
        }"
          class="px-4 py-2 bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-900 transition-colors duration-150 rounded">Previous
        </button>
        @for (item of displayedButtons(); track item) {
          <button (click)="activeIndex.set(item.index)"
              [ngClass]="{
              'bg-primary-500': item.index === activeIndex(),
              'bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-900 hover:bg-gray-300 transition-colors duration-150': item.index !== activeIndex()
              }"
            class="px-4 py-2 rounded">
            {{ item.version }}
          </button>
        }
        <button
          (click)="activeIndex.set(activeIndex() + 1)"
          [disabled]="activeIndex() >= availableVersions().length - 1"
        [ngClass]="{
        'bg-gray-100 dark:bg-gray-900': activeIndex() >= availableVersions().length - 1,
        'hover:bg-gray-300': activeIndex() < availableVersions().length - 1,
        }"
          class="px-4 py-2 bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-900 hover:bg-gray-300 transition-colors duration-150 rounded">Next
        </button>
      </div>
      <hr>
      }
      <div class="flex flex-col gap-6 p-8 overflow-auto" style="max-height: 60vh">
        <ng-container *rxapMethod="let changelog call getChangelogMethod; parameters: getChangelogMethodParameters()">
          @for (general of changelog.general; track general) {
            <markdown [data]="general" class="prose dark:prose-invert">
            </markdown>
          }
          @for (application of changelog.application; track application) {
            <markdown [data]="application" class="prose dark:prose-invert">
            </markdown>
          }
        </ng-container>
      </div>
    </div>
  }
